<template>
  <main-layout>
    <template slot="header-title">{{ $t('customer.title') }}</template>

    <template slot="header-actions">
      <common-button @click="openBubbleCreation = true">Add bubble</common-button>
    </template>

    <template slot="main">
      <bubbles-ui-sidebar-create
        v-if="openBubbleCreation"
        @close="
          () => {
            openBubbleCreation = false
          }
        "
      />

      <div class="container mx-auto">
        <div class="bg-white shadow rounded">
          <k-tabs class="p-5">
            <k-tab name="Bubbles" :tags="[{ content: bubblesSorted.length }]" :selected="true">
              <!-- <div class="bubbles-list">
                <data-filter :bubbleType="!bubblesFilters.type" @handle="handleFilterBubble"></data-filter>
                <bubble v-for="bubble in bubblesSorted" v-bind:key="bubble.id" :id="bubble.id"></bubble>
              </div> -->
              <bubbles-factory></bubbles-factory>
            </k-tab>

            <k-tab name="All" :tags="[{ content: total }]">
              <data-filter :bubble="true" @handle="handleFilterCustomers"></data-filter>
              <div v-if="loadingCustomer" class="customers-list">
                <div class="content-palceholder" v-for="n in 24" :key="n">
                  <div class="avatar"></div>
                  <div class="name"></div>
                  <div class="email"></div>
                </div>
              </div>
              <div v-else class="customers-list">
                <customer v-for="customer in customersSorted" v-bind:key="customer.id" :id="customer.id"></customer>
              </div>
              <el-pagination
                v-if="!loadingCustomer"
                background
                layout="prev, pager, next"
                @current-change="handlePagination"
                :page-size="itemPerPage"
                :current-page.sync="page"
                :total="total"
              >
              </el-pagination>
            </k-tab>
          </k-tabs>
        </div>
      </div>
    </template>
  </main-layout>
</template>

<script>
import Empty from '@/components/box-entity-empty.vue'
import DataFilter from '@/components/common/filter.vue'
import Customer from '@/components/customers/customer-card.vue'
import Bubble from '@/components/customers/bubble.vue'
import { mapActions, mapGetters } from 'vuex'

import bubblesFactory from '@/components/bubbles/bubbles-factory.vue'

export default {
  name: 'customers-list',

  components: { Empty, Customer, Bubble, DataFilter, bubblesFactory },

  data() {
    return {
      loadingCustomer: true,
      loadingBubbles: true,
      page: 1,
      customersFilters: {
        bubbles: []
      },
      bubblesFilters: {
        events: [],
        type: null
      },
      openBubbleCreation: false
    }
  },
  computed: {
    ...mapGetters('customers', {
      customers: 'customers',
      total: 'getTotal'
    }),
    ...mapGetters('bubbles', {
      bubbles: 'bubbles'
    }),

    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    customersSorted: function() {
      return this.customers.slice().sort(function(a, b) {
        return a.id - b.id
      })
    },

    bubblesSorted: function() {
      let bubbles = this.bubbles

      bubbles.forEach(bubble => {
        if (bubble.datestart && bubble.dateend) {
          bubble.datestart = this._getDate(bubble.datestart, this.site.timezone)
          bubble.dateend = this._getDate(bubble.dateend, this.site.timezone)
        }
        if (bubble.request) {
          for (let index = 0; index < bubble.request.length; index++) {
            if (bubble.request[index].datestart && bubble.request[index].dateend) {
              bubble.request[index].datestart = this._getDate(bubble.request[index].datestart, this.site.timezone)
              bubble.request[index].dateend = this._getDate(bubble.request[index].dateend, this.site.timezone)
            }
          }
        }
      })

      if (this.bubblesFilters.type) {
        bubbles = bubbles.filter(bubble => bubble.type === this.bubblesFilters.type)
      }
      bubbles = bubbles.slice().sort(function(a, b) {
        return new Date(b.dateupdate) - new Date(a.dateupdate)
      })

      return bubbles
    },

    nbPages() {
      return Math.round(this.total / 25)
    },

    itemPerPage() {
      if (this.customersSorted.length > 25) {
        return this.customersSorted.length
      } else {
        return 25
      }
    }
  },
  watch: {
    site: function(site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('customers', ['loadCustomersPage', 'filterByBubbles']),
    ...mapActions('bubbles', ['loadBubbles']),

    init() {
      if (this.site) {
        this.loadCustomersPage({ page: 0 }).then(() => {
          this.loadingCustomer = false
        })

        this.loadBubbles().then(() => {
          this.loadingBubbles = false
        })
      }
    },

    handlePagination(page) {
      this.loadingCustomer = true
      if (page < 1) {
        page = 0
      } else {
        page--
      }
      this.loadCustomersPage({ page: page }).then(() => {
        this.loadingCustomer = false
      })
    },

    handleFilterCustomers(filter) {
      if (filter.action && filter.action === 'delete') {
        // Remove filter
        if (filter.type === 'bubble') {
          this.customersFilters.bubbles.splice(
            this.customersFilters.bubbles.findIndex(bubble => bubble.id === filter.bubble.id),
            1
          )
        }
      } else {
        // Add new filter
        if (filter.type === 'bubble') {
          this.customersFilters.bubbles.push(filter.bubble)
        }
      }

      this.reloadBubbles()
    },

    reloadBubbles() {
      this.loadingCustomer = true
      // Sort result by filter
      let promises = []
      promises.push(this.filterByBubbles({ bubbles: this.customersFilters.bubbles }))

      Promise.all(promises).then(() => {
        this.loadingCustomer = false
      })
    },

    handleFilterBubble(filter) {
      if (filter.action && filter.action === 'delete') {
        if (filter.type === 'bubbleType') {
          this.bubblesFilters.type = null
        }
      } else {
        if (filter.type === 'event') {
          this.bubblesFilters.events.push(filter.event.alias)
        }

        if (filter.type === 'bubbleType') {
          this.bubblesFilters.type = filter.search
        }
      }
    },

    closeBubbleCreation() {
      this.openBubbleCreation = false
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
.customers-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-row-gap: 12px;
  grid-column-gap: 24px;
}
ul.pagination {
  text-align: center;
  li {
    display: inline-block;
    text-align: center;
    margin: 12px 4px;
    border-radius: 4px;
    a {
      display: block;
      text-align: center;
      padding: 10px 12px;
      color: #555;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
    }
    &:hover {
      background: rgba(45, 45, 45, 0.1);
    }

    &.active {
      background: #fbbe36;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
      a {
        color: #fff;
      }
    }
  }
}

.content-palceholder {
  align-items: center;
  font-size: 14px;
  display: grid;
  padding: 0 0 12px 0;
  height: 80px;
  border-bottom: 1px solid #dedede;
  grid-template-columns: 80px 1fr 24px;
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    'avatar name actions'
    'avatar email actions';
  .avatar {
    grid-area: avatar;
    width: 60px;
    height: 60px;
    border-radius: 4px;
  }
  .name {
    grid-area: name;
    height: 16px;
    width: 40%;
    border-radius: 4px;
  }
  .email {
    grid-area: email;
    height: 16px;
    width: 60%;
    border-radius: 4px;
  }
  .actions {
    grid-area: actions;
  }

  div {
    -webkit-animation-duration: 1s;
    -webkit-animation-fill-mode: forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: placeholderSkeleton;
    -webkit-animation-timing-function: linear;
    background: #f6f7f8;
    background-image: -webkit-gradient(
      linear,
      left center,
      right center,
      from(#f6f7f8),
      color-stop(0.2, #edeef1),
      color-stop(0.4, #f6f7f8),
      to(#f6f7f8)
    );
    background-image: -webkit-linear-gradient(left, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-repeat: no-repeat;
    position: relative;
  }
}

@-webkit-keyframes placeholderSkeleton {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

@-webkit-keyframes skeletonAnimate {
  from {
    background-position: top left;
  }
  to {
    background-position: top right;
  }
}

.el-pagination {
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Customer/CustomerList.vue